<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<h2 class="h2"><a id="page_vii"></a>Contents</h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td style="width:5%" valign="top"><p class="para"> </p></td>
<td style="width:95%" valign="top"><p class="para"><a href="#/xhtml/frontmatter02">Acknowledgments</a></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"> </p></td>
<td style="width:95%" valign="top"><p class="para"><a href="#/xhtml/frontmatter03">Foreword by Lt. Michael E. Thornton</a></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"> </p></td>
<td style="width:95%" valign="top"><p class="para"><a href="#/xhtml/frontmatter04">Preface by J. Terry Riebling</a></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"> </p></td>
<td style="width:95%" valign="top"><p class="para"><a href="#/xhtml/frontmatter05">Author’s Note</a></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"> </p></td>
<td style="width:95%" valign="top"><p class="para"> </p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para">  <a href="#/xhtml/chapter01">1</a></p></td>
<td style="width:95%" valign="top"><p class="para"><a href="#/xhtml/chapter01">The Fourth of July</a></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para">  <a href="#/xhtml/chapter02">2</a></p></td>
<td style="width:95%" valign="top"><p class="para"><a href="#/xhtml/chapter02">Thank You, Richard Widmark</a></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para">  <a href="#/xhtml/chapter03">3</a></p></td>
<td style="width:95%" valign="top"><p class="para"><a href="#/xhtml/chapter03">Blood, Sweat, and Sand</a></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para">  <span href="#/xhtml/chapter04" title="Link target outside of Sample">4</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Gearing Up</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para">  <span href="#/xhtml/chapter05" title="Link target outside of Sample">5</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter05" title="Link target outside of Sample">First Op</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para">  <span href="#/xhtml/chapter06" title="Link target outside of Sample">6</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter06" title="Link target outside of Sample">First Blood</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para">  <span href="#/xhtml/chapter07" title="Link target outside of Sample">7</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Tools of the Trade</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para">  <span href="#/xhtml/chapter08" title="Link target outside of Sample">8</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter08" title="Link target outside of Sample">The Death Tax</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para">  <span href="#/xhtml/chapter09" title="Link target outside of Sample">9</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Good Ops, Bad Ops, and Grand Theft Auto</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Reason to Celebrate</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter11" title="Link target outside of Sample">Fishy Intel</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter12" title="Link target outside of Sample">First Tour—Last Dance</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter13" title="Link target outside of Sample">13</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter13" title="Link target outside of Sample">Good Night, Saigon</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter14" title="Link target outside of Sample">14</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter14" title="Link target outside of Sample">The Rung Sat Secret Zone</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><a id="page_viii"></a><span href="#/xhtml/chapter15" title="Link target outside of Sample">15</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter15" title="Link target outside of Sample">First Contact—Second Tour</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter16" title="Link target outside of Sample">16</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter16" title="Link target outside of Sample">Dead Men Walking</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter17" title="Link target outside of Sample">17</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter17" title="Link target outside of Sample">Australian Bliss</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter18" title="Link target outside of Sample">18</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter18" title="Link target outside of Sample">Back to the Bush</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter19" title="Link target outside of Sample">19</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter19" title="Link target outside of Sample">A Little Walk in the Bush</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter20" title="Link target outside of Sample">20</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter20" title="Link target outside of Sample">First Command</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter21" title="Link target outside of Sample">21</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter21" title="Link target outside of Sample">Last Dance—Second Tour, 1969</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter22" title="Link target outside of Sample">22</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter22" title="Link target outside of Sample">Grapes of Wrath</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter23" title="Link target outside of Sample">23</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter23" title="Link target outside of Sample">Welcome to the Neighborhood</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter24" title="Link target outside of Sample">24</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter24" title="Link target outside of Sample">Looking for Trouble</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter25" title="Link target outside of Sample">25</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter25" title="Link target outside of Sample">Down Under Op</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter26" title="Link target outside of Sample">26</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter26" title="Link target outside of Sample">Dickey’s Revenge</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"><span href="#/xhtml/chapter27" title="Link target outside of Sample">27</span></p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/chapter27" title="Link target outside of Sample">Fair Winds and Following Seas</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"> </p></td>
<td style="width:95%" valign="top"><p class="para"> </p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"> </p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">Glossary</span></p></td>
</tr>
<tr>
<td style="width:5%" valign="top"><p class="para"> </p></td>
<td style="width:95%" valign="top"><p class="para"><span href="#/xhtml/backmatter02" title="Link target outside of Sample">Index</span></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?29035f02